import { render } from "./InputFieldLabel.vue?vue&type=template&id=487351d2&scoped=true"
import script from "./InputFieldLabel.vue?vue&type=script&lang=js"
export * from "./InputFieldLabel.vue?vue&type=script&lang=js"

import "./InputFieldLabel.vue?vue&type=style&index=0&id=487351d2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487351d2"]])

export default __exports__